import { IonContent, useIonPopover } from "@ionic/react";
import { ReactNode } from "react";
import { FormattedMessage } from "react-intl";

import styles from "@components/popovers/Popover.module.css";

type Props = {
  children: ReactNode;
  textKey: string;
};

const AlertPopover = ({ children, textKey }: Props) => {
  const [presentPopover, dismissPopover] = useIonPopover(
    <IonContent class="ion-padding">
      <FormattedMessage id={textKey} />
    </IonContent>
  );

  return (
    <div
      onClick={e => {
        presentPopover({
          alignment: "center",
          cssClass: styles.alertPopover,
          event: e.nativeEvent,
          showBackdrop: false,
          side: "bottom"
        });
        setTimeout(() => {
          dismissPopover();
        }, 2000);
      }}
    >
      {children}
    </div>
  );
};

export default AlertPopover;
